import React from 'react';
import { Flex } from '@spothero/ui';
import { VenueEventSEMEdit } from '../events/landing/VenueEventLandingEdit';
import { useHeaderHeight } from 'hooks/use-header-height';
export const VenueLandingPage = () => {
    const headerHeight = useHeaderHeight();
    // Dynamic View Height - used to ensure the height of the page adjusts to the viewport height on mobile devices.
    // Reference: https://web.dev/blog/viewport-units
    return (<Flex height={`calc(100dvh - ${headerHeight})`} data-testid="VenueLandingPage" background="white">
            <VenueEventSEMEdit />
        </Flex>);
};
